import { Hint, IHintConfig } from '../hint/Hint'
import PrebidFacade from '../prebidFacade/PrebidFacade'
import SlotFactory from '../slots/SlotFactory'

export class ContentHints {
  static readonly MOBILE_SELECTOR = '.content_mobile_hint, .content_hint'
  static readonly DESKTOP_SELECTOR = '.content_desktop_hint, .content_hint'
  static readonly SLOT_CLASS: SlotClass = 'Content'
  private hintConfig: IHintConfig

  constructor(prebidFacade: PrebidFacade, slotFactory: SlotFactory) {
    // Expose public API to call render for SPAs, etc
    window.$mediavine.web.fillContentHints = () => this.render()

    this.hintConfig = {
      desktopSelector: ContentHints.DESKTOP_SELECTOR,
      mobileSelector: ContentHints.MOBILE_SELECTOR,
      prebidFacade,
      slotFactory,
      slot: ContentHints.SLOT_CLASS
    }

    this.render()
  }

  render(): boolean {
    return Hint.addSlotsToHints(this.hintConfig)
  }
}
